<template>
  <div>
    <h1 id="title">Submission Form</h1>
    <form @submit.prevent="submitForm">
      <label for="name">Name:</label><br>
      <input type="text" id="name" name="name" placeholder="John Smith" v-model="formData.name"><br>
      <p v-if="shouldShowError('formData.name')" class="error-message">Fill out this field!</p>
      <label for="email">Email:</label><br>
      <input type="email" id="email" name="email" placeholder="example@email.com" v-model="formData.email"><br>
      <label for="gender">Gender:</label><br>
      <select id="gender" name="gender" v-model="formData.gender">
        <option disabled value="default">Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      </select><br>
      <label for="mobile">Mobile (10 Digits):</label><br>
      <input type="tel" id="mobile" name="mobile" placeholder="0000 00 00 00" pattern="[0-9]{10}" v-model="formData.mobile"><br>
      <label for="dob">Date of Birth:</label><br>
      <VueDatePicker id="dob" :format="dateFormat" :enable-time-picker="false" v-model="formattedDob"></VueDatePicker>
      <p>Selected Date: {{ selectedDate }}</p>
      <label for="hobbies">Hobbies:</label><br>
      <input type="text" id="hobbies" name="hobbies" placeholder="Cooking, Reading..." v-model="formData.hobbies"><br>
      <!--
        <label for="picture">Picture:</label><br>
        <input type="file" id="picture" name="picture" v-model="formData.picture"><br>
      -->
      <label for="currentAddress">Current Address:</label><br>
      <input type="text" id="currentAddress" name="currentAddress" placeholder="111B 12" v-model="formData.currentAddress"><br>
      <label for="city">City:</label><br>
      <input id="city" name="city" placeholder="New York" v-model="formData.city"><br>      
      <input type="submit" value="Submit" id="submit">
    </form>

    <!-- Modal -->
    <div class="modal" v-show="showModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <h2 id="submission-title">Submitted Information</h2>
        <table class="submitted-info-table">
          <tr v-for="(value, key) in filteredFormDataWithCapitalizedKeys" :key="key">
            <td class="table-key">{{ capitalizeFirstLetter(key) }}</td>
            <td class="table-value">{{ value }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {
    VueDatePicker,
  },
  data() {
    return {
      formData: {
        gender: 'default'
      },
      formSubmitted: false, // Added flag to track form submission
      showModal: false,
      selectedDate: null,
      dateFormat: 'yyyy-MM-dd', // Customize the date format as needed
    };
  },
  methods: {
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getFormattedDate(date) {
      if(date){
        // Implement logic to parse the formatted date and return a Date object
        // Example: If the format is 'DD MM YYYY', you may split the string and create a Date object
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
      }
      else return null;
    },
    formatKey(key){
      switch(key){
        case 'dob': return "Date of Birth";
        case 'currentAddress': return "Current Address"
        default: return this.capitalizeFirstLetter(key);
      }
    },
    shouldDisplayField(key) {
    // If the field is 'gender' and its value is 'default', don't display it
    return key !== 'gender' || this.formData[key] !== 'default';
    },
    isRequired(fieldName) {
      // Define a function to check if a field is required
      const requiredFields = ['formData.name'];
      return requiredFields.includes(fieldName);
    },
    submitForm() {
      // Check if required fields are filled out before submission
      if (!this.formData.name) {
        // Show the error message
        this.formSubmitted = true;
        return;
      }

      // Convert form data to JSON
      const formDataJson = JSON.stringify(this.formData);
      console.log('LOG:' + formDataJson);

      // Set the formSubmitted flag to true
      this.showModal = true;
    },
    closeModal() {
      // Close the modal
      this.showModal = false;
      this.formSubmitted = false;
    },
    shouldShowError(fieldName) {
      return this.formSubmitted && !this.formData[fieldName];
    }
  },
  computed: {
    filteredFormData() {
      // Create a copy of formData and filter out 'gender' if its value is 'default'
      const filteredData = { ...this.formData };
      if (filteredData.gender === 'default') delete filteredData.gender;
      return filteredData;
    },
    filteredFormDataWithCapitalizedKeys() {
      return Object.fromEntries(
        Object.entries(this.filteredFormData).map(([key, value]) => [this.formatKey(key), value])
      );
    },
    formattedDob: {
      get() {
        // Return the formatted date for display
        if (this.formData.dob) {
          return this.formData.dob; // Adjust the format as needed
        } 
        else {
          return null;
        }
      },
      set(value) {
        // Set the original value to formData.dob
        this.formData.dob = this.getFormattedDate(value);
      },
    },
  }
};
</script>

<style>
form {
  width: 300px;
  margin: 0 auto;
  text-align: left;
}

label {
  display: block;
  margin-top: 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-primary);
}

form input,
form select {
  width: 100%;
  margin-top: 0.3125rem;
}

input[type="submit"] {
  margin-top: 1.25rem;
  width: 100%;
  background: linear-gradient(135deg, var(--accent), #8b5cf6);
  color: #ffffff;
  font-weight: 500;
}

input[type="submit"]:hover {
  opacity: 0.9;
}

.error-message {
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.modal {
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  background-color: var(--bg-primary);
  margin: 15% auto;
  padding: 1.25rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  width: 80%;
  max-width: 40rem;
}

.submitted-info-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.submitted-info-table td {
  border: 1px solid var(--border);
  padding: 0.5rem;
  text-align: left;
  color: var(--text-primary);
}

.submitted-info-table .table-key {
  font-weight: bold;
  background-color: var(--bg-sidebar);
}

.close {
  color: var(--text-muted);
  float: right;
  font-size: 1.75rem;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: var(--text-primary);
  text-decoration: none;
  cursor: pointer;
}
</style>